const getUniqueArray = (mixedArray) => {
    let newArray = [];
    let uniqueObject = {};
    for (let i in mixedArray) {
        let objTitle = mixedArray[i]['name'];
        uniqueObject[objTitle] = mixedArray[i];
    }
    for (let i in uniqueObject) {
        newArray.push(uniqueObject[i]);
    }
    return newArray;
};

const checkedName = (data) => {
    return data.fileData === null ? data.name : data.fileData.name;
  };
  
const getRecordAttachmentsToBeAdded = (record) => {
  if (
    typeof record.attachmentFiles !== 'undefined' &&
    record.attachmentFiles.length > 0
  ) {
    return record.attachmentFiles.filter((x) => x.newlyAdded === true);
  }
  return [];
};

const getRecordAttachmentsToBeDeleted = (record) => {
  let existingAttahments = [];
  if (typeof record.existingAttachmentFiles !== 'undefined') {
    existingAttahments = record.existingAttachmentFiles;
  }

  function comparer(otherArray) {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          // eslint-disable-next-line
          return checkedName(other) == checkedName(current);
          // eslint-disable-next-line
        }).length == 0
      );
    };
  }
  var result = existingAttahments.filter(comparer(record.attachmentFiles));
  return result;
};

export { getUniqueArray, getRecordAttachmentsToBeAdded, getRecordAttachmentsToBeDeleted };